import React from "react";
import Container from "@material-ui/core/Container";
import { makeStyles, styled } from "@material-ui/core/styles";
import { Chip, colors } from "@material-ui/core";
import { Done } from "@material-ui/icons";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
  chip: {
    paddingLeft: "10px",
    paddingRight: "10px",
    marginLeft: "10px",
  },
}));

const ListItem = styled("li")(({ theme }) => ({
  margin: theme.spacing(0.5),
}));

const UnitsFilters = (props) => {
  const { selectUnit,
    rowUpdate,
   changAutoCurrUnits} = props;
  const classes = useStyles();
  const { t } = useTranslation(["forms"]);

  return (
    <Container
      style={{
        display: "flex",
        justifyContent: "center",
        flexWrap: "wrap",
        listStyle: "none",
        padding: "0px",
        margin: "0px",
      }}
      component="ul"
    >
      {rowUpdate?.UnitsTable.map((x) => {
        return (
          <ListItem key={x.unit}>
            {x.unit === selectUnit.unit ? (
              <Chip
                className={classes.chip}
                label={t(x.unitName)}
                icon={<Done />}
                style={{
                  backgroundColor: colors.green[300] ,
                  color: "#fff",
                  fontWeight:"bold"
                }}
                clickable
              />
            ) : 
            (
              <Chip
                className={classes.chip}
                label={t(x.unitName)}
                variant="outlined"
                color={ "green"}
                style={{
                    fontWeight:"bold"
                  }}
                onClick={() => {
                    changAutoCurrUnits({...x});
                }}
              />
            )}
          </ListItem>
        );
      })}
    </Container>
  );
};

export default UnitsFilters;
